module.exports = __webpack_public_path__ + "img/aqfh-img-23.4aae6648.png";